import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { BillingParty } from "../../../graphql/billing_party.datatypes";

interface OverpaidBillingPartiesData {
    overpaidBillingParties: BillingParty[];
}

export const gqlOverpaidBillingParty = `
    id
    overduePayments
    cost
    outstandingBalance
    code

    primaryPayingMember {
        id
        primary_paying_member
        first_name
        last_name
    }
    booking {
        id

        group {
            id
            name

            tour {
                id
                display_name
            }
        }
    }

`;

const GET_OVERPAID_BILLING_PARTIES_QUERY = gql`
  query getOverpaidBillingParties{
      overpaidBillingParties{
        ${gqlOverpaidBillingParty}
    }
  }
`;

const getOverpaidBillingParties = () =>
    useQuery<OverpaidBillingPartiesData>(GET_OVERPAID_BILLING_PARTIES_QUERY, {
        variables: {},
        fetchPolicy: 'network-only'
    });

export default getOverpaidBillingParties;
